module.exports = __webpack_public_path__ + "static/media/slide_1-layer_1.9063147e.png";